export const CRUD_LABEL_PROPS = {
	label: {
		requred: true,
		type: String,
		default: ""
	},
	labelHint: {
		required: false,
		type: String,
		default: ""
	},
	showLabel: {
		requred: true,
		type: Boolean,
		default: true
	},
	hasCheckBox: {
		requred: false,
		type: Boolean,
		default: false
	},
	checkboxData: {
		requred: false,
		type: Object,
		default: () => {}
	},
	classList: {
		requred: false,
		type: String,
		default: ""
	},
	subLabel: {
		requred: false,
		type: String,
		default: ""
	},
}
